module.exports = __webpack_public_path__ + "img/speaker-3-1.c7443894.jpg";